import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';

export function TryAgain({ onSubmit }) {
  return (
    <div className="try-again">
      <div className="heading-4 mb-1_5">Something went wrong</div>
      <Button color="success" onClick={onSubmit}>
        Try again
      </Button>
    </div>
  );
}

TryAgain.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};
